export function VideoCallSample() {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", backgroundColor: "#000" }}>
      <video
        src="/video-call-sample.webm"
        controls
        autoPlay
        style={{ maxWidth: "100%", maxHeight: "100vh" }}
      />
    </div>
  );
}
